<div class="loader" *ngIf="isAllCallOverviewLoading">
    <app-three-dots-blinking></app-three-dots-blinking>
</div>
<div class="container" *ngIf="!isAllCallOverviewLoading">
    <div class="container-wrapper">
        <div class="header">
            <div class="header-overview">
                <h2>{{'reporting.Overview' | transloco}}</h2>
                <p class="description">
                    {{moduleName}} {{'reporting.CONSISTS_Of' | transloco}} {{allCallOverview.length}} {{ allCallOverview.length > 1 ? ('reporting.CALLS' | transloco) :
                    ('reporting.CALL' | transloco) }}
                </p>
            </div>
            <div class="statistics-overview">
                <div class="label">
                   {{'reporting.CALL_OVERVIEW_LABEL' | transloco}}:
                </div>
                <div class="statistics-info">
                    <div class="stats-label">
                        <img src="/assets/icons/green-circle.svg">
                        <p>{{'reporting.PASSED' | transloco}}</p>
                    </div>
                    <div class="stats-label">
                        <img src="/assets/icons/blue-circle-0.6.svg">
                        <p>{{'reporting.ATTEMPTED' | transloco}}</p>
                    </div>
                    <div class="stats-label">
                        <img src="/assets/icons/yellow-circle-0.6.svg">
                        <p>{{'reporting.NOT_ATTEMPTED' | transloco}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="body">
            <div class="body-wrapper">
                <div class="call-list" *ngFor="let call of allCallOverview">
                    <div class="left-section">
                        <div class="img" *ngIf="call.callThumbnail">
                            <img *ngIf="call.callThumbnail" [src]="call.callThumbnail"
                                alt="https://placehold.co/125x71">
                            <img *ngIf="!call.callThumbnail" src="https://placehold.co/125x71"
                                alt="https://placehold.co/125x71">

                        </div>
                        <div class="call-wrapper">
                            <div class="call-name">
                                <div class="call-label" *ngIf="call.callType === 'GUIDED'"> {{'reporting.GUIDED_CALL' | transloco}} ({{
                                    call.noOfQuestions}} {{ call.noOfQuestions > 1 ? ('reporting.QUESTIONS' | transloco) : ('reporting.QUESTION' | transloco) }})
                                </div>
                                <div class="call-label" *ngIf="call.callType === 'CONVERSATIONAL'"> {{'reporting.CONVERSATIONAL_CALL' | transloco}}
                                </div>
                            </div>
                            <div class="call-description">
                                {{call.callName}}
                            </div>
                            <div class="attempts">
                                <div class="avg">{{ call.avgNoOfAttempts | number:'1.1-1' }} </div>
                                <div class="label">{{'reporting.AVG_ATTEMPTS' | transloco}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="right-section">
                        <div class="bar">
                            <div class="statistics">
                                <div class="number">{{call.callProgressOverview.completed.numberOfMembers}} /
                                    {{call.callProgressOverview.completed.numberOfMembers +
                                    call.callProgressOverview.inProgress.numberOfMembers +
                                    call.callProgressOverview.notStarted.numberOfMembers}} {{'reporting.USERS_PASSED' | transloco}}</div>
                                <div class="percentage">{{call.callProgressOverview.completed.percentage}}%</div>
                            </div>
                            <div class="progress-bar-container">
                                <div class="progress-wrapper"
                                    [ngStyle]="{ 'width': call.callProgressOverview.completed.percentage + '%' }">
                                    <div class="progress completed"
                                                [ngClass]="{'right-rounded': call.callProgressOverview.inProgress.percentage === 0 && call.callProgressOverview.notStarted.percentage === 0}"
                                    ></div>
                                    <div class="tooltip"><img src="/assets/icons/green-circle.svg"> {{
                                        call.callProgressOverview.completed.percentage }}% {{'reporting.PASSED' | transloco}}</div>
                                </div>

                                <div class="progress-wrapper"
                                    [ngStyle]="{ 'width': call.callProgressOverview.inProgress.percentage + '%' }">
                                    <div 
                                        class="progress in-progress"
                                        [ngClass]="{'left-rounded': call.callProgressOverview.completed.percentage === 0,
                                                    'right-rounded': call.callProgressOverview.notStarted.percentage === 0}"
                                    ></div>
                                    <div class="tooltip"><img src="/assets/icons/blue-circle.svg"> {{
                                        call.callProgressOverview.inProgress.percentage }}% {{'reporting.ATTEMPTED' | transloco}}</div>
                                </div>

                                <div class="progress-wrapper"
                                    [ngStyle]="{ 'width': call.callProgressOverview.notStarted.percentage + '%' }">
                                    <div 
                                        class="progress not-started"
                                        [ngClass]="{'left-rounded': call.callProgressOverview.completed.percentage === 0 && call.callProgressOverview.inProgress.percentage === 0}"
                                    ></div>
                                    <div class="tooltip"><img src="/assets/icons/yellow-circle.svg"> {{
                                        call.callProgressOverview.notStarted.percentage }}% {{'reporting.NOT_ATTEMPTED' | transloco}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="cta" (click)="toggleSidePane(call)">{{'reporting.DETAILED_ANALYSIS' | transloco}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
